import axios from 'axios'
import { CADASTRAR_CONEXAO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarConexao (conexao) {
  const url = `${URL}/rota/conexoes/cadastrar`;
  return dispatch => axios.post(url,conexao , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type:CADASTRAR_CONEXAO ,
        payload: response
      })
  );
}
